import {
  NEW_MESSAGE_SOUND,
  NEW_ORDER_SOUND,
} from "../assets/sounds/notificationSound";

const MIN_MS_BETWEEN_MESSAGE_SOUND_STARTS = 10 * 1000;
const AUDIO_UNLOCK_KEY = "kd_notif_audio_unlocked";
const SILENT_WAV =
  "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAE=";

let messageAudioUnlocked = false;
let lastMessageSoundStartTime = 0;

function resolvePayloadTitle(payload) {
  const n = payload?.notification || {};
  const data = payload?.data || {};
  return String(n.title || data.title || "").trim();
}

export function resolveNotificationSoundSrc(payload) {
  const raw = resolvePayloadTitle(payload);
  const lower =
    typeof raw.toLocaleLowerCase === "function"
      ? raw.toLocaleLowerCase("tr-TR")
      : raw.toLowerCase();
  const asciiFold = lower
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ı/g, "i")
    .replace(/ş/g, "s")
    .replace(/ğ/g, "g")
    .replace(/ü/g, "u")
    .replace(/ö/g, "o")
    .replace(/ç/g, "c");

  if (
    lower.includes("sipariş") ||
    lower.includes("siparis") ||
    asciiFold.includes("siparis") ||
    asciiFold.includes("yeni siparis")
  ) {
    return NEW_ORDER_SOUND;
  }
  return NEW_MESSAGE_SOUND;
}

export function resolveNotificationSoundType(payload) {
  return resolveNotificationSoundSrc(payload) === NEW_ORDER_SOUND
    ? "order"
    : "message";
}

export function restoreFcmAudioUnlockFromSession() {
  try {
    if (sessionStorage.getItem(AUDIO_UNLOCK_KEY) === "1") {
      messageAudioUnlocked = true;
    }
  } catch {
    /* ignore */
  }
}

export function markFcmAudioUnlocked() {
  messageAudioUnlocked = true;
  try {
    sessionStorage.setItem(AUDIO_UNLOCK_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function tryUnlockFcmAudio() {
  if (messageAudioUnlocked || typeof Audio === "undefined") {
    return;
  }
  try {
    const audio = new Audio(SILENT_WAV);
    audio.volume = 0.0001;
    void audio.play().then(() => {
      markFcmAudioUnlocked();
    }).catch(() => {});
  } catch {
    messageAudioUnlocked = false;
  }
}

export function playFcmNotificationSound(payload, { fromBackground = false } = {}) {
  if (typeof Audio === "undefined" || !payload) {
    return false;
  }

  const src = resolveNotificationSoundSrc(payload);
  const isOrderSound = src === NEW_ORDER_SOUND;

  if (!isOrderSound && !messageAudioUnlocked && !fromBackground) {
    return false;
  }

  if (!isOrderSound) {
    const now = Date.now();
    if (
      lastMessageSoundStartTime > 0 &&
      now - lastMessageSoundStartTime < MIN_MS_BETWEEN_MESSAGE_SOUND_STARTS
    ) {
      return false;
    }
    lastMessageSoundStartTime = now;
  }

  try {
    const audio = new Audio(src);
    audio.volume = 0.85;
    void audio.play().catch((err) => {
      if (process.env.NODE_ENV === "development") {
        console.warn("FCM notification sound play rejected:", err);
      }
    });
    return true;
  } catch (e) {
    if (process.env.NODE_ENV === "development") {
      console.warn("notification sound error", e);
    }
    return false;
  }
}

export function playFcmNotificationSoundByType(soundType, payload = null) {
  const syntheticPayload =
    soundType === "order"
      ? { notification: { title: "Yeni Sipariş" } }
      : { notification: { title: "Yeni mesaj" } };
  return playFcmNotificationSound(payload || syntheticPayload, {
    fromBackground: true,
  });
}
